import React, { Component } from 'react';
import { Link } from 'react-router-dom';

import { localizer, languages } from '../Translator'
import '../custom.css'

import Grid from '@material-ui/core/Grid';
import { AppBar } from '@material-ui/core';
import Typography from '@material-ui/core/Typography'
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem'
import { Button } from "@material-ui/core"
import { withStyles } from '@material-ui/core/styles'
import CloseOutlinedIcon from '@material-ui/icons/CloseOutlined'
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import Chip from '@material-ui/core/Chip';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import Avatar from '@material-ui/core/Avatar';

import Roles from "./Utilities/Roles"

import AuthCli from '../sdk/AuthCli'
import ConfigCli from '../sdk/ConfigCli';


const ListItemStyled = withStyles({
  root: {   
     boxShadow: '0px 0px 0px 1px rgba(0,0,0,0.2)',
     //boxShadow: '0px 0px 0px 2px rgba(0,0,0,0.5),  0px 2px 4px rgba(0,0,0,0.1),0px 4px 8px rgba(0,0,0,0.1),0px 8px 16px rgba(0,0,0,0.1)',
    "&:hover": {
      backgroundColor: "var(--custom-primary100-color)",
      boxShadow: 'inset 0px 1px 1px 1px rgba(0, 0, 0, 0.2)',
      borderRadius: '4px',
      
      color: "white",
      "& .MuiListItemIcon-root": {
        color: "white"
      },
      "& .MuiMenu-list": {
        paddingTop: '0px !important',
        paddingBottom: '0px !important'
      },
      "& .MuiList-root.MuiMenu-list.MuiList-padding": {
        paddingTop: '0px !important',
        paddingBottom: '0px !important'
      }
    }
  },
  selected: {}
})(ListItem);

const MenuItemStyle = withStyles({
  root: {   
    "&:hover": {
      backgroundColor: "var(--custom-primary100-color)",      
    }
  },
  selected: {}
})(MenuItem);

const LOGIN_PATH = "/login"
const FORGOTPASS_PATH = "/forgotpass"
const RECOVERPASS_PATH = "/recoverpassword"
const EMAIL_VALIDATE_PATH = "/user/email/validate"
const SIGNUP_PATH = '/signup'

export class Layout extends Component {
  constructor(props) {
    super(props)
    this.state = {
      selectedMenu: "",

      // Currently logged in user.
      session: null,
      showCultures: false,

      openLanguageMenu: false,
      languageMenu: null,
      culture: "en",

      openRealmsMenu: false,
      currentRealm: null,
      positionRealmMenu: null,
      realms: null,
      currentUrl: null
    }
  }

  displayName = Layout.name

  componentDidMount() {
    // This is used to display the version of the application. Only works for pre and production environments.
    ConfigCli.GetSystemInfo().then(info => { if (info) this.setState({ systemInfo: info }) })
    
    // Get role for the user.
    AuthCli.GetSessionInfo().then(session => {
      if (session) this.setState({ session: session })
    })

    var culture = window.localStorage.getItem("culture")
    if (culture) this.setState({ culture: culture })

    let currentUrl = window.location.pathname
    if (currentUrl) this.setState({ currentUrl: currentUrl })
  }
   
  handleLogOut = async (event) => {
    // Tell service to close session.
    await AuthCli.LogOut()
    // go to login page
    window.location.href = "login"
  }
  

  handleLanguageMenu = (event) => {
    this.setState({ languageMenu: event.currentTarget, openLanguageMenu: true })
  }

  onClickMenu = (event) => {
    this.setState({ selectedMenu: event.target.closest("button").name })
  }

  doCloseSubMenu = () => {
    // Chosing word with no match with any sub menu options
    this.setState({ selectedMenu: "none" })
  }
  
  onCloseLanguageMenu = (event) => {
    this.setState({ openLanguageMenu: false })
    let selectValue = event.nativeEvent.target.innerText;
    let culture = languages.find((language) => language.name === selectValue)
    let culturePrev = this.state.culture
    
    if (culture && culture.code) {
      if (culture.code !== culturePrev) {
        this.setState({ culture: culture.code })
        window.localStorage.setItem("culture", culture.code)
        // Refresh page
        window.location.reload(false)
      }
    }

  }

  handleChangeGroupMenu = (event) => {
    let positionRealmMenu = event.currentTarget
    AuthCli.GetAvailableRealmsForSession().then(realms => {

      if (!realms || realms.length === 0) return

      realms = realms.filter(r => !r.realm.startsWith("system") && !r.realm.startsWith("FACTORY__"))
      let currentRealm = realms.find(r => r.userId === this.state.session.userId && r.realm === this.state.session.realm && r.role === this.state.session.role)
      this.setState({ currentRealm: currentRealm, realms: realms, openRealmsMenu: true, positionRealmMenu: positionRealmMenu })
    })
  }
  
  onCloseRealMenu = (event) => {
    this.setState({ openRealmsMenu: false })

    let selectValue = event.currentTarget.dataset;
    if (!selectValue.realm) return
    
    let values = selectValue.realm.split("$$")
    let realm = this.state.realms.find(r => r.userId === values[0] && r.realm === values[1] && r.role === values[2])
        
    if (realm === this.state.currentRealm) return
    AuthCli.ChangeSessionRealm(realm.realm).then((data) => {
      if (data !== null && data.toString().startsWith("[ERR")) {
        this.setState({
          loginFailureMessage: data.toString().substring(data.indexOf(' '))
        })
      } else {
        this.setState(previousState => ({
          session: {
            ...previousState.session,
            realm: realm.realm,
            role: realm.role
          }
        }), () => { window.location.reload(false) })
      }
    })
  }

  formatSessionUserName = () => {
    return this.state.session && this.state.session.userEmail ? this.state.session.userEmail.toLowerCase() : ""
  }

  formatSessionRoleRealm = () => {
    if (!this.state.session) return ""

    if (this.state.session.role === Roles.ROLE_USER.Name) return "(" + this.state.session.realm + ")"
    
    return this.state.session.role + " - (" + this.state.session.realm + ")"
  }

  render() {
    const currentPath = window.location.pathname
    const isDocs = currentPath === '/docs/api' || currentPath.startsWith('/docs/api/')

    const isLogin = this.state.currentUrl &&
      (this.state.currentUrl.endsWith(LOGIN_PATH) ||
        this.state.currentUrl.endsWith(FORGOTPASS_PATH) ||
        this.state.currentUrl.endsWith(RECOVERPASS_PATH) ||
        this.state.currentUrl.endsWith(SIGNUP_PATH) ||
        this.state.currentUrl.endsWith(EMAIL_VALIDATE_PATH))
   
    return (
    
      <React.Fragment>

        {/** Heading application bar. */}
        {!isDocs && <AppBar position="fixed" color="default" className="appbar-custom" >
          <Grid container direction="row">
            <Grid item md={2}>
              <Link to="/">
                <img src="images/postamail_logo.png" alt="PostaMail Logo" style={{ margin: "10px" }} />
              </Link>
            </Grid>
            <Grid item md={6}>
              {this.state.session && !isLogin && <Button className="button-generic main-menu" name={localizer.AppBarShipmentsManagement} onClick={this.onClickMenu}>{localizer.AppBarShipmentsManagement}<div id="shipments-mark" className='submenu-mark' style={{ display: this.state.selectedMenu === localizer.AppBarShipmentsManagement ? "block" : "none" }}></div></Button>}
            </Grid>
            <Grid container item md={4} justify='flex-end' >
              <Grid item md={!this.state.session ? 12 : 3} style={{ textAlign: 'right' }}>
                <Button className="button-generic main-menu" onClick={this.handleLanguageMenu} style={{ minWidth: "unset" }}><i className="fa-solid fa-earth-europe font-size-20"></i></Button>
                <Menu className='p-0'
                  anchorEl={this.state.languageMenu}
                  getContentAnchorEl={null}
                  id="language-menu"
                  keepMounted
                  transformOrigin={{ vertical: 'bottom', horizontal: 'center' }}
                  PaperProps={{
                    style: {
                      width: 'auto',
                      height: 'auto',
                      margin: '0 auto'
                    },
                  }}
                  anchorOrigin={{
                    vertical: 130,
                    horizontal: 'center',
                  }}
                
                  open={this.state.openLanguageMenu}
                  onClose={this.onCloseLanguageMenu}
                  
                >
                  {languages.map(language => {
                    let srcImage = "images/" + language.code + ".svg"
                    return (
                      <MenuItemStyle className={language.code === this.state.culture ? "card-ListItem" : "cursor-pointer"}
                        key={language.code} value={language.code} onClick={this.onCloseLanguageMenu}>
                        <img src={srcImage} alt="flag" className='icon-flag-circle' />
                        <Typography className={language.code === this.state.culture ? "typography-generic  color-txt-primary font-weight-bold " : "typography-generic"}>{language.name}</Typography>
                      </MenuItemStyle>
                    )
                  })}
                </Menu>
              

                {!this.state.session ?
                  <Button className="button-generic main-menu" style={{ minWidth: "unset" }} name={localizer.Identify} onClick={() => { window.location.href = "login" }} startIcon={<i className="fa-solid fa-user font-size-20" />}>
                    <div id="user-mark" className='submenu-mark' style={{ display: this.state.selectedMenu === localizer.Identify ? "block" : "none" }}></div>
                  </Button>
                  :
                
                  <Button className="button-generic main-menu" style={{ minWidth: "unset" }} name={localizer.Identify} onClick={this.onClickMenu} startIcon={<i className="fa-solid fa-user font-size-20" />}>
                    <div id="user-mark" className='submenu-mark' style={{ display: this.state.selectedMenu === localizer.Identify ? "block" : "none" }}></div>
                  </Button>
                
                }
              </Grid>
              {this.state.session &&
                <Grid item md={9}><Typography className="typography-generic"> {this.formatSessionUserName()}<br />{this.formatSessionRoleRealm()}</Typography></Grid>
              }
              
            </Grid>
              
            <Grid id="shipments-sub-menu" container item md={12} direction="row" style={{ background: 'var( --custom-primary-color)', padding: 0, display: this.state.selectedMenu === localizer.AppBarShipmentsManagement ? "flex" : "none" }}>
              <Button className="button-generic sub-menu" href="outbox"><i className="fa-solid fa-boxes-packing font-size-25"></i> {localizer.AppBarShipments}</Button>
              <Button className="button-generic sub-menu" href="saved"><i className="fa-solid fa-floppy-disk font-size-25"></i> {localizer.AppBarShipmentsSaved}</Button>
              <Button className="button-generic sub-menu" href="inbox"><i className="fa-solid fa-inbox font-size-25"></i> {localizer.AppBarInbox}</Button>
              {(this.state.session && this.state.session.role === Roles.ROLE_ADMIN.Name) && <Button className="button-generic sub-menu" href="billing"><i className="fa-solid fa-file-invoice-dollar font-size-25"></i> {localizer.AppBarBilling}</Button>}
              <CloseOutlinedIcon className="closeoutlinedicon-custom" style={{ position: "absolute", top: "60px", right: "10px" }} onClick={this.doCloseSubMenu}></CloseOutlinedIcon>
            </Grid> 

            <Grid id="user-sub-menu" container item md={12} direction="row" justify="flex-end" alignItems="flex-end" style={{ background: 'var( --custom-primary-color)', display: this.state.selectedMenu === localizer.Identify ? "flex" : "none" }}>
              {(this.state.session && this.state.session.role === Roles.ROLE_ADMIN.Name) && <Button className="button-generic sub-menu" href="invitations"><i className="fa-solid fa-handshake font-size-25"></i>{localizer.AppBarInvitations}</Button>}
              {(this.state.session && this.state.session.role === Roles.ROLE_ADMIN.Name) && <Button className="button-generic sub-menu" href="users"><i className="fa-solid fa-users font-size-25"></i>{localizer.GroupUsers}</Button>}
              {this.state.session && <Button className="button-generic sub-menu" href="postaladdress"><i className="fa-solid fa-address-card font-size-25"></i>{localizer.PostalAddress}</Button>}
              {this.state.session && <Button className="button-generic sub-menu" href="emailaddress"><i className="fa-solid fa-at font-size-25"></i> {localizer.EmailAddress}</Button>}
              {this.state.session && <Button className="button-generic sub-menu" href="replacepassword" ><i className="fa-solid fa-unlock-keyhole font-size-25"></i>{localizer.ReplacePasswordMain}</Button>}
             
              <Button className="button-generic sub-menu" onClick={this.handleChangeGroupMenu} ><i className="fa-solid fa-people-arrows font-size-25"></i>{localizer.ChangeGroup}</Button>
              
              <Menu className='p-0'
                anchorEl={this.state.positionRealmMenu}
                getContentAnchorEl={null}
                id="realms-menu"
                keepMounted
                //anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
                transformOrigin={{ vertical: 'top', horizontal: 'center' }}
                PaperProps={{
                  style: {
                    width: 'auto',
                    height: 'auto',
                    margin: '0 auto'
                  },
                }}
                anchorOrigin={{
                  vertical: 60,
                  horizontal: 'center',
                }}
                
                open={this.state.openRealmsMenu}
                onClose={this.onCloseRealMenu}>
                <List className='p-0' component="nav" aria-label="">
                  {this.state.realms && this.state.realms.map(realm => {
                    return (                      
                      <ListItemStyled
                        className={realm === this.state.currentRealm ? "card-ListItem" : "cursor-pointer"}
                        alignItems="flex-start"
                        data-realm={realm.userId + "$$" + realm.realm + "$$" + realm.role}
                        key={realm.userId + "$$" + realm.realm + "$$" + realm.role}
                        value={realm.userId + "$$" + realm.realm + "$$" + realm.role}
                        onClick={realm !== this.state.currentRealm ? this.onCloseRealMenu : () => { this.setState({ openRealmsMenu: false }) }}>
                        <ListItemAvatar>
                          <Avatar className="bg-primary" alt="" ><i className="fa-solid fa-building"></i></Avatar>
                        </ListItemAvatar>
                        <ListItemText
                          primary={<Typography className={realm === this.state.currentRealm ? "typography-generic  color-txt-primary font-weight-bold " : "typography-generic  color-txt-primary"}>
                            {realm.realm.toUpperCase()}
                            {realm === this.state.currentRealm &&
                              <Chip className='chip'
                                variant="outlined"
                                size="small"
                                icon={<i className="fa-solid fa-check icon-chip"></i>}
                                label={<Typography className="typography-generic xsmall color-white font-weight-bold pl-0">{localizer.Selected}</Typography>}                            
                              />
                            }
                          </Typography>}
                          secondary={
                            <Typography className="typography-generic color-gray" component="p">
                              {localizer.LoginInRealmAs}{realm.role.toUpperCase()}
                            </Typography>
                          }
                        />
                      </ListItemStyled>
                    )
                  })
                  }
                </List>
              </Menu>

              <Button className="button-generic sub-menu" onClick={this.handleLogOut} ><i className="fa-solid fa-right-from-bracket font-size-25"></i>{localizer.Logout}</Button>
              {/*  <Typography className="typography-generic mr-25"> {userlogged}<br />{usergroup}</Typography> */}
              <CloseOutlinedIcon className="closeoutlinedicon-custom" style={{ position: "absolute", top: "60px", right: "10px" }} onClick={this.doCloseSubMenu}></CloseOutlinedIcon>
            </Grid>
          </Grid>
          
        </AppBar>}

        {/* Main application content. */}
        <Grid container style={{ marginTop: isDocs ? 0 : 53, marginBottom: 50 }}>
          {this.props.children}
        </Grid>

        {/* Footer bar. */}
        <Grid container item md={12} alignItems="center" className="footer-custom">
          {/* PostaMail logo. */}
          <Grid item md={2}>
            <img src="images/postamail-logo-bglight.png" alt="PostaMail Logo" className="ml-20"/>
          </Grid>
          {/* Copyright and links. */}
          <Grid item md={8}>
            <Typography className="typography-generic layout" color="inherit">
              ©{new Date().getFullYear()} - Mailcomms Group &nbsp;|&nbsp;
           
              <strong><Link className="link-hover font-weight-bold" to="/conditions" target="_blank" rel="noreferrer">{localizer.TermsAndConditions}</Link></strong>&nbsp;|&nbsp;
              <strong><Link className="link-hover font-weight-bold" to="/privacy" target="_blank" rel="noreferrer">{localizer.DataProtectionPolicy}</Link></strong>&nbsp;|&nbsp;
              <strong><Link className="link-hover font-weight-bold" to="/cookies" target="_blank" rel="noreferrer">{localizer.CookiesPolicy}</Link></strong>
            </Typography>
          </Grid>
          {/* W3C logo. */}
          <Grid item md={2} className="text-align-right pr-20">
              <img id="image0" alt="" width="75" height="26" src="https://www.w3.org/WAI/wcag21/wcag2.1AA-blue-v.png" />
          </Grid>
        </Grid>

      </React.Fragment>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/Layout.js